import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { InfoBoxComponent } from '../../utility/info-box/info-box.component';
import { AppointmentStepperService } from '../../../services/appointment-stepper.service';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { LoadDocumentsModalComponent } from '../../modals/load-documents-modal/load-documents-modal.component';
import { AssistanceFormComponent } from '../../assistance-form/assistance-form.component';
import { IDocumentCard, IDocumentEmitter } from '../../../interfaces/document-card.interface';
import { UserAccountDTO } from '../../../classes/user-account.dto';
import { HttpService } from '../../../services/http.service';
import { StorageService } from '../../../services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { DocumentCardComponent } from '../../document-card/document-card.component';
import { ModalWithTwoButtonsComponent } from '../../modals/modal-with-two-buttons/modal-with-two-buttons.component';

@Component({
    selector: 'app-request-selection',
    imports: [ReactiveFormsModule, TranslateModule, InfoBoxComponent, AssistanceFormComponent, DocumentCardComponent],
    templateUrl: './request-selection.component.html',
    styleUrl: './request-selection.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RequestSelectionComponent implements OnInit, OnDestroy {
  @Input() hasTravel?: boolean;
  @Input() hasDocuments?: boolean;
  @Output() requestSelectionEmitter: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  @Output() emitAssistanceForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  requestSelectionData: any = {
    form: {
      textareaId: 'reason',
    },
  };
  reasonInputArea?: FormControl = new FormControl(null, [Validators.required]);
  inputsForm?: FormGroup;
  subscriptions: Array<Subscription> = [];
  uploadedFiles: Array<IDocumentCard> = [];

  constructor(
    private fb: FormBuilder,
    private appointmentStepperService: AppointmentStepperService,
    private modal: NzModalService,
    private http: HttpService,
    private storage: StorageService,
    private toast: ToastrService,
    private translate: TranslateService
  ) {}

  public ngOnInit(): void {
    this.inputsForm = this.fb.group({
      [this.requestSelectionData.form.textareaId]: this.reasonInputArea,
    });
    const oldValues = this.appointmentStepperService.getSelectionData();
    if (oldValues) {
      this.inputsForm.patchValue(oldValues.value);
    }
    this.emitRequestSelectionForm();
  }

  private emitRequestSelectionForm(): void {
    if (this.inputsForm) {
      this.subscriptions.push(
        this.inputsForm.valueChanges.subscribe((_): void => {
          this.requestSelectionEmitter.emit(this.inputsForm);
        })
      );
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
  }

  public openModal(): void {
    const modalRef: NzModalRef<LoadDocumentsModalComponent> = this.modal.create({
      nzContent: LoadDocumentsModalComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: { isFromMedicalConsultations: true },
      },
    });
    modalRef.afterClose.subscribe((result: { event: string; documentData: IDocumentCard }): void => {
      this.uploadedFiles.push(result.documentData);
    });
  }

  protected actionCard(event: IDocumentEmitter): void {
    const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
    const individualId = userData?.individualId;
    if (event.eventType === 'delete') {
      const textsModal = this.translate.instant('deleteDocumentModal');
      const activeModal = this.modal.create({
        nzContent: ModalWithTwoButtonsComponent,
        nzClosable: true,
        nzFooter: null,
        nzData: {
          dataModal: {
            colorActionButton: 'red',
            texts: {
              ...textsModal,
              first_button_pointer: 'delete',
            },
            actionButton: () => {
              this.http.deleteDocument(individualId, event.idDoc).subscribe({
                next: (_) => {
                  activeModal.close();
                  this.toast.success(this.translate.instant('reportsPage.deleted_successfully'));
                  this.removeDocument(event.idDoc);
                },
              });
            },
          },
        },
      });
    } else if (event.eventType === 'download') {
      this.http.downloadSingleDocument(individualId, event.docName, true).subscribe((urlObj: { docUrl: string }) => {
        const link = document.createElement('a');
        link.href = urlObj.docUrl;
        link.download = event.docName;
        link.click();
      });
    }
  }

  private removeDocument(idDoc: string): void {
    this.uploadedFiles = this.uploadedFiles.filter((file: IDocumentCard) => file.id !== idDoc);
  }

  protected assistanceFormData(event: FormGroup): void {
    this.emitAssistanceForm.emit(event);
  }
}
